import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title() { return 'W.O.R.K.'; }

  public get currentYear() { return new Date().getFullYear(); }

  public get version() { return 'v2025.5'; }
}

